import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTaskTypes = (
    backend: string,
    token: string,
) => {

    return fetch(
        `${getApiUrl(backend)}tasktypes`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getTaskTypes;
